<template>
  <div class="item-container">
    <div
      :id="`itemexpander-${item.jsonid}`"
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title">
        <i class="icon-travel_insurance_light glyph-lg mr-3 pl-0" />
        <span>{{ item.title.toUpperCase() }}</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>{{ item.duration }}</h6>
        <h6>{{ item.area }}</h6>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>Commencing on {{ item.startdate }}</h6>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div v-if="dropdown" class="item-dropdown">
      <div class="item-dropdown-main d-flex flex-column flex-lg-row">
        <ul>
          <li v-if="item.startdate" class="mobile-dropdown-item">
            <h4>Commencing on</h4>
            <p>{{ item.startdate }}</p>
          </li>
          <li v-if="item.insurancefor">
            <h4>Insurance for</h4>
            <p>{{ item.insurancefor }}</p>
          </li>
          <li v-if="item.inclcover">
            <h4>Insurance Includes</h4>
            <div>
              <p>{{ item.inclcover }}</p>
              <p v-if="alreadyTravelling" class="pt-0">
                Already Travelling Endorsement
              </p>
            </div>
          </li>
          <li v-if="item.area">
            <h4>Area</h4>
            <p>{{ item.area }}</p>
          </li>
          <li v-if="item.bookdate">
            <h4>Taken out on</h4>
            <p>{{ item.bookdate }}</p>
          </li>
          <li v-if="item.status">
            <h4>Status</h4>
            <p>{{ item.status }}</p>
          </li>
        </ul>
        <div
          class="insurance-details w-100 d-flex flex-column align-items-center"
        >
          <topuptext />
          <!-- Commented Out Until We get Flag from SF -->
          <!-- <PrivateHealthCare :item="item" /> -->
          <button
            v-if="Object.keys(travelInsCoverNote).includes('data')"
            id="coverNoteButton"
            class="m-0"
            @click="showTravelInsCoverNote"
          >
            <span>Travel Insurance Policy Certificate</span>
          </button>
          <button
            v-for="(link, index) in insLinks"
            :key="index"
            class="mt-2 ins-btns"
            @click="
              () => {
                openLink(link.link);
              }
            "
          >
            <i class="material-icons vtd-mr-3">picture_as_pdf</i>
            <span>{{ link.title }}</span>
          </button>
          <b-button 
            :href="ipidHref"
            target="_blank"
            class="btn-info ins-btns"
          >
            Insurance Product Information Document
          </b-button>
        </div>
      </div>
      <div v-if="item.fnotes[0]" class="extra-info-notes">
        Notes
        <ul>
          <li v-for="(note, index) in item.fnotes" :key="index">
            {{ note }}
          </li>
        </ul>
      </div>
      <p class="insurance-number">
        Your Trailfinders Travel Insurance policy number is
        {{ bookingNumber }}
      </p>
    </div>
    <InsuranceCoverNote ref="InsuranceCoverNoteRef" />
  </div>
</template>

<script>
import topuptext from "./insurance-topup-text";
import { mapGetters } from "vuex";
import InsuranceCoverNote from "@/modules/menu-bar/insurance-cover-note";
// import PrivateHealthCare from "./insurance-private-health-care";
export default {
  components: {
    topuptext,
    InsuranceCoverNote,
    // PrivateHealthCare
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    insOnly: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      dropdown: true,
      travelInsCoverNote: {},
      ipidHref: ''
    };
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: "essentialInfoMenu/getMenu",
    }),
    bookingNumber() {
      return this.$store.getters["booking/getBookingNumber"];
    },
    insLinks() {
      if (!this.item || !this.item.inslinks) return null;
      return this.item.inslinks.filter((link) => link.title && link.link);
    },
    emergencyClaimsLink() {
      let emergencyLink;
      this.insLinks.forEach((item) => {
        if (item.title === "Emergency Claims & Policy Document") {
          emergencyLink = item.link;
        } else {
          emergencyLink = null;
        }
      });
      return emergencyLink;
    },
    alreadyTravelling() {
      if (this.item.alreadytravelling === "TRUE") {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.$refs["itemexpander-0"]) {
      this.$refs["itemexpander-0"].click();
    }
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
    if (this.essentialInfoMenu) {
      this.setTravelInsCoverNote();
    }
    if (this.insOnly <= 2) {
      this.dropdown = true;
    }
    this.getIPIDHref()
  },
  methods: {
    setTravelInsCoverNote() {
      this.essentialInfoMenu.forEach((info) => {
        if (Array.isArray(info.submenu)) {
          info.submenu.forEach((item) => {
            if (
              item.title === "Travel Insurance Policy Certificate" &&
              item.data
            ) {
              this.travelInsCoverNote = item;
            }
          });
        }
      });
    },
    showTravelInsCoverNote() {
      this.$refs.InsuranceCoverNoteRef.getInsuranceCoverNotePDF(
        this.emergencyClaimsLink
      );
    },
    getIPIDHref() {
      const insObj = this.essentialInfoMenu && this.essentialInfoMenu.find((item) => item.title === 'Travel Insurance')
      const ipidItem = insObj && insObj.submenu && insObj.submenu.find((item) => item.title === 'IPID')
      this.ipidHref = ipidItem ? ipidItem.href : ''
    },
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    collapseAll() {
      this.dropdown = false;
    },
    expandAll() {
      this.dropdown = true;
    },
    openLink(link) {
      window.open(link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
